const { $document, $window } = require('../lib/selectors');
// include featherlight for pop-up images
require('featherlight');
const throttle = require('lodash.throttle');

// how tall the image should ever be including the legend
const MAX_HEIGHT = 0.95;
let SHADOWBOX_OPEN = false;

initFeatherlight();
$window.resize(throttle(resizeOpenedShadowbox, 250));
$document.ajaxComplete(() => {
  initFeatherlight();
});

function initFeatherlight() {
  if ($('.shadowbox').length) {
    $('.shadowbox').featherlight({
      previousIcon: '<span class="icon-left-arrow"></span>',
      nextIcon: '<span class="icon-right-arrow"></span>',
      closeIcon: '<span title="close" class="close-shadow"></span>',

      beforeOpen: () => {
        $('body').addClass('shadowBoxOpen');
        SHADOWBOX_OPEN = true;
      },

      afterClose: () => {
        $('body').removeClass('shadowBoxOpen');
        SHADOWBOX_OPEN = false;
      },

      afterOpen: function(){
        const totalSlides = $.featherlight.current().$source.length;
        const currentSlide = $.featherlight.current().currentNavigation() + 1;
        const str = `<div class="counter"><span class="count-num">${currentSlide}</span> / ${totalSlides}</div>`;
        this.$instance.find('.featherlight-content').prepend(str);
      },

      afterContent: function() {
        const caption = this.$currentTarget.find('img').attr('alt');
        this.$instance.find('.legend').remove();
        $('<div class="legend">')
          .text(caption)
          .appendTo(this.$instance.find('.featherlight-content'));
        setMaxLegendSize();

        // set counter
        //const totalSlides = $.featherlight.current().$source.length;
        const currentSlide = $.featherlight.current().currentNavigation() + 1;
        this.$instance.find('.count-num').text(currentSlide);
      },
    });
  }
}

function setMaxLegendSize() {
  if ($('div.featherlight').length) {
    const imgWidth = $('div.featherlight img').width();
    $('.legend').css('max-width', `${imgWidth}px`);
  }
}

function setImageSize() {
  const windowHeight = window.innerHeight;
  const legendHeight = $('.legend').outerHeight(true);
  const allowHeight = (windowHeight - legendHeight) * MAX_HEIGHT;
  const vh = allowHeight / windowHeight * 100;
  $('.featherlight-image').css('max-height', `${vh}vh`);
}

function resizeOpenedShadowbox() {
  if (SHADOWBOX_OPEN) {
    setImageSize();
  }
}
